module.exports = __webpack_public_path__ + "static/media/twitter-social-media-svgrepo-com.dd34a2c4.svg";